import { Component } from 'react';

// Evita tela em branco: erros de renderização do conteúdo são repassados via onError
// (exibidos no popup de alerta) e o conteúdo quebrado deixa de ser renderizado.
export class ContentErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error('[ContentErrorBoundary] Erro de renderização:', error, info?.componentStack);
    this.props.onError?.(error);
  }

  render() {
    return this.state.failed ? null : this.props.children;
  }
}
